"use client";

import type * as React from "react";
import Box from "@mui/material/Box";
import { useColorScheme } from "@mui/material/styles";

const HEIGHT = 60;
const WIDTH = 60;

type Color = "dark" | "light";

export interface LogoProps {
	color?: Color;
	emblem?: boolean;
	height?: number;
	width?: number;
}

const LogoSVGComponent = ({ height, width, color }: { height: number; width: number; color: Color }) => {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 2943.000000 496.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g
				transform="translate(0.000000,496.000000) scale(0.100000,-0.100000)"
				fill={color === "light" ? "white" : "black"}
				stroke="none"
			>
				<path
					d="M2179 4945 c-14 -8 -32 -28 -39 -45 -12 -29 -2 -62 155 -523 169
-495 327 -895 367 -929 11 -10 36 -18 58 -18 21 0 47 8 59 18 39 32 172 374
347 892 188 554 189 559 137 600 -25 20 -37 20 -542 20 -426 -1 -521 -3 -542
-15z"
				/>
				<path
					d="M20780 4578 c-66 -26 -151 -107 -183 -175 -32 -69 -32 -237 0 -305
30 -65 105 -143 167 -173 134 -65 316 -31 419 79 58 63 80 122 85 226 3 81 0
104 -19 155 -30 81 -112 164 -192 193 -78 30 -200 29 -277 0z"
				/>
				<path
					d="M12199 3808 c0 -674 -1 -712 -17 -688 -99 144 -254 267 -426 339
-229 95 -591 102 -851 15 -392 -131 -681 -468 -770 -900 -56 -270 -40 -587 40
-830 131 -395 411 -677 774 -779 135 -37 225 -49 381 -49 350 0 626 120 807
349 l58 74 3 -199 2 -200 315 0 315 0 -2 1788 -3 1787 -312 3 -313 2 -1 -712z
m-500 -813 c179 -61 326 -192 410 -367 72 -151 86 -219 85 -418 -1 -195 -17
-271 -90 -419 -39 -79 -62 -110 -133 -181 -60 -60 -107 -97 -156 -123 -179
-92 -408 -108 -598 -42 -234 81 -400 285 -464 569 -21 96 -21 307 0 403 57
254 193 441 392 539 122 60 191 74 345 70 106 -2 138 -7 209 -31z"
				/>
				<path
					d="M8221 4288 c-5 -13 -334 -761 -731 -1663 -397 -902 -726 -1650 -731
-1663 l-9 -22 338 0 337 0 151 368 150 367 819 0 819 0 150 -365 151 -365 344
-3 c324 -2 343 -1 337 15 -4 10 -332 768 -728 1686 l-722 1667 -333 0 -333 0
-9 -22z m629 -1366 c161 -391 291 -714 288 -717 -3 -3 -272 -4 -600 -3 l-594
3 298 725 c163 399 298 727 298 730 1 11 29 -55 310 -738z"
				/>
				<path
					d="M26270 4305 c0 -2 254 -372 565 -820 l564 -815 -610 -863 -610 -862
368 -3 c202 -1 373 0 379 2 6 2 201 279 434 615 233 337 427 610 431 609 4 -2
200 -279 434 -615 l426 -613 386 0 c307 0 383 3 376 13 -6 6 -281 400 -612
875 l-602 864 17 26 c10 15 259 374 554 797 295 424 539 776 544 783 6 9 -71
12 -371 11 l-378 0 -388 -570 -389 -570 -386 570 -387 571 -372 0 c-205 0
-373 -2 -373 -5z"
				/>
				<path
					d="M19000 3765 l0 -355 -180 0 -180 0 0 -220 0 -220 180 0 180 0 0 -673
c0 -808 4 -852 87 -1026 49 -104 169 -224 273 -275 133 -64 211 -80 405 -80
141 0 185 4 256 21 139 35 379 139 379 165 0 16 -131 422 -139 430 -4 4 -43
-8 -86 -27 -108 -46 -186 -65 -270 -65 -136 0 -226 56 -262 162 -15 48 -17
115 -21 711 l-3 657 370 0 371 0 0 220 0 220 -370 0 -370 0 0 355 0 355 -310
0 -310 0 0 -355z"
				/>
				<path
					d="M1297 4009 c-9 -5 -23 -22 -31 -37 -24 -47 -1266 -3289 -1266 -3306
0 -31 24 -65 55 -81 28 -13 93 -15 433 -15 417 0 449 3 475 43 40 63 1017
2118 1017 2140 0 39 -546 1217 -576 1245 -27 23 -76 29 -107 11z"
				/>
				<path
					d="M4042 4007 c-13 -6 -32 -27 -41 -46 -51 -100 -494 -1179 -494 -1201
0 -14 225 -504 500 -1090 471 -1005 502 -1066 534 -1082 31 -16 72 -18 415
-18 253 0 392 4 413 11 31 11 61 52 61 83 0 12 -1145 3009 -1247 3264 -35 87
-77 110 -141 79z"
				/>
				<path
					d="M14150 3519 c-122 -14 -275 -48 -389 -85 -107 -35 -471 -208 -471
-224 0 -10 205 -379 218 -392 4 -4 47 13 96 41 439 246 922 262 1135 36 85
-89 121 -189 121 -332 l0 -83 -427 0 c-533 0 -640 -12 -836 -91 -110 -44 -176
-88 -268 -179 -94 -93 -144 -178 -176 -300 -27 -101 -24 -311 5 -414 67 -235
245 -428 477 -517 117 -46 193 -60 355 -66 337 -13 608 74 802 256 l78 73 0
-151 0 -151 305 0 306 0 -4 922 c-3 917 -3 924 -25 1007 -97 364 -362 583
-785 645 -114 17 -388 20 -517 5z m713 -1556 c11 -170 -28 -277 -143 -394
-129 -131 -313 -199 -540 -199 -158 0 -294 52 -375 142 -57 64 -80 131 -79
233 1 175 93 275 288 310 49 9 190 13 457 14 l386 1 6 -107z"
				/>
				<path
					d="M17205 3515 c-217 -41 -392 -133 -535 -282 -42 -43 -86 -91 -98 -108
l-21 -30 -1 208 0 207 -315 0 -315 0 0 -1755 0 -1755 315 0 315 0 2 678 3 677
32 -46 c43 -62 137 -157 208 -209 282 -208 763 -246 1139 -90 246 102 478 336
588 592 157 364 157 864 0 1226 -66 152 -135 255 -252 372 -162 161 -322 249
-549 301 -117 28 -402 35 -516 14z m261 -501 c238 -61 429 -256 505 -514 31
-106 38 -353 14 -471 -82 -408 -412 -653 -804 -599 -315 43 -531 248 -608 577
-14 59 -18 115 -17 233 1 185 19 264 91 410 81 164 235 298 408 354 117 38
289 42 411 10z"
				/>
				<path
					d="M24845 3523 c-411 -53 -727 -238 -930 -543 -35 -52 -77 -126 -94
-163 -178 -398 -153 -952 61 -1306 152 -252 414 -455 689 -535 156 -45 270
-59 464 -59 137 0 207 5 295 21 277 50 527 172 707 346 l74 71 -164 163 -164
164 -88 -71 c-188 -151 -371 -214 -615 -213 -246 1 -439 84 -576 250 -62 75
-137 219 -158 302 l-13 55 956 5 956 5 3 150 c10 477 -116 846 -366 1076 -221
202 -490 291 -867 287 -77 0 -153 -3 -170 -5z m360 -480 c101 -25 203 -81 283
-157 61 -58 81 -85 117 -160 46 -97 60 -145 71 -243 l7 -63 -682 0 -682 0 7
38 c11 64 64 215 94 267 84 145 225 262 372 306 130 40 285 44 413 12z"
				/>
				<path
					d="M20610 2225 l0 -1285 315 0 315 0 -2 1283 -3 1282 -312 3 -313 2 0
-1285z"
				/>
				<path
					d="M21344 3473 c8 -21 226 -587 486 -1258 260 -671 477 -1232 482 -1248
l10 -27 325 2 326 3 488 1275 c269 701 489 1278 489 1283 0 4 -141 7 -314 7
l-313 0 -329 -990 c-180 -544 -331 -990 -334 -990 -3 0 -156 444 -340 988
l-335 987 -327 3 -327 2 13 -37z"
				/>
				<path
					d="M2667 2068 c-26 -26 -497 -1365 -497 -1412 0 -17 11 -39 29 -57 l29
-29 497 0 c423 0 500 2 525 15 32 16 50 43 50 72 0 19 -472 1349 -492 1387
-18 33 -40 45 -81 46 -26 0 -45 -7 -60 -22z"
				/>
			</g>
		</svg>
	);
};

export function Logo({ color = "dark", height = HEIGHT, width = WIDTH }: LogoProps): React.JSX.Element {
	return (
		<Box height={height} width={width}>
			<LogoSVGComponent height={height} width={width} color={color} />
		</Box>
	);
}

export interface DynamicLogoProps {
	colorDark?: Color;
	colorLight?: Color;
	emblem?: boolean;
	height?: number;
	width?: number;
}

export function DynamicLogo({
	colorDark = "light",
	colorLight = "dark",
	height = HEIGHT,
	width = WIDTH,
	...props
}: DynamicLogoProps): React.JSX.Element {
	const { colorScheme } = useColorScheme();
	const color = colorScheme === "dark" ? colorDark : colorLight;

	return <Logo color={color} height={height} width={width} {...props} />;
}
